<div class="sla-details" [class.sla-details--compact]="compactLayout">
    <div class="sla-details__main">
        <div class="sla-details__icon" (click)="onRestartSLA()"
            [ngClass]="{ 'cursor-pointer': isAllowedToRecalculate }">
            <img [matTooltip]="
                    (!!readyForBillingDate ? 'APP_CASES.CASE_ALREADY_INSPECTION_COMPLETED' : slaDetails?.SLAType)
                        | translate
                " matTooltipPosition="above" class="sla-details__icon-image"
                [src]="slaDetails | slaTypeImageSource : caseReportList : readyForBillingDate" alt="sla-type" />
        </div>

        <div class="sla-details__content">
            <div class="sla-details__grid">
                <div class="sla-details__column sla-details__column--left">
                    <div class="sla-details__item sla-details__item--start">
                        <span class="title">{{ "APP_CASES.SLA_START_DATE" | translate }}</span>
                        <span class="colon">:</span>
                        <span class="sub-title">{{ slaDetails?.SLAStartDate | pcxDateFormate : false }}</span>
                    </div>

                    <div class="sla-details__item sla-details__item--delay">
                        <span class="title">{{ "APP_CASES.DELAY" | translate }}</span>
                        <span class="colon">:</span>
                        <span class="sub-title">{{
                            slaDetails?.IsSLADelayed ? ("APP_CASES.YES" | translate) : ("APP_CASES.NO" | translate)
                            }}</span>
                    </div>
                </div>

                <div class="sla-details__column sla-details__column--right">
                    <div class="sla-details__item sla-details__item--expire">
                        <span class="title">{{ "APP_CASES.SLA_EXPIRE_DATE" | translate }}</span>
                        <span class="colon">:</span>
                        <span class="sla-details__expire-value">
                            <span class="sub-title">{{ slaDetails?.SLAExpiredDate | customIsoDate : true : true
                                }}</span>
                            @if (!hideOverdueBadge) {
                            @if (slaDetails | slaDaysLeft : caseReportList : readyForBillingDate; as timeLeft) {
                            <span class="sla-details__time-left"
                                [class.sla-details__time-left--overdue]="timeLeft.isOverdue">
                                <i class="pi pi-calendar sla-details__time-left-icon" aria-hidden="true"></i>
                                <span class="sla-details__time-left-text">{{ timeLeft.label }}</span>
                            </span>
                            }
                            }
                        </span>
                    </div>

                    @if (slaDetails?.IsSLADelayed) {
                    <div class="sla-details__item sla-details__item--informed">
                        <span class="title">{{ "APP_CASES.SLA_INFORM_DATE" | translate }}</span>
                        <span class="colon">:</span>
                        @if (slaDetails?.SLADelayInformedTime) {
                        <span class="sub-title">{{ slaDetails.SLADelayInformedTime | pcxDateFormate : true }}</span>
                        } @else {
                        <span class="sub-title">{{ "N/A" | translate }}</span>
                        }
                    </div>
                    }
                </div>
            </div>

            @if (slaDetails?.IsSLADelayed) {
            <div class="sla-details__reason">
                <span class="sla-details__reason-title">{{ "APP_CASES.SLA_DELAY_REASON" | translate }} :</span>
                @if (slaDetails?.SLADelayReason) {
                <span class="sla-details__reason-text">{{
                    translatedDelayReason
                    }}</span>
                } @else {
                <span class="sla-details__reason-text">{{ "N/A" | translate }}</span>
                }
            </div>
            }
        </div>
    </div>
</div>